<style>
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #000;
  color: #fff;
  padding: 8px;
  text-decoration: none;
  z-index: 100;
}

.skip-link:focus {
  top: 0;
}
</style>

<script>
import "@fontsource/kumbh-sans";
// import "@fontsource/kumbh-sans/100.css";
// import "@fontsource/kumbh-sans/200.css";
import "@fontsource/kumbh-sans/300.css";
// Defaults to weight 400
// import "@fontsource/kumbh-sans/500.css";
import "@fontsource/kumbh-sans/600.css";
// import "@fontsource/kumbh-sans/700.css";
import "@fontsource/kumbh-sans/800.css";
import { onMount } from "svelte";
import { toasts, FlatToast } from "svelte-toasts";

import {
  // browser,
  dev,
} from "$app/environment";
import { PUBLIC_TRACEWAY_CONNECTION_STRING } from "$env/static/public";
import { beforeNavigate, afterNavigate } from "$app/navigation";
import { resolve } from "$app/paths";
import { page } from "$app/state";

// import "@fontsource/kumbh-sans/900.css";

import { ProgressBar } from "$lib/components";
import { ToastContainer } from "$lib/components";
import {
  Footer,
  Header,
  GoogleAnalytics,
  // Loader,
  ScrollTop,
} from "$lib/components";
import { locales, localizeHref } from "$lib/paraglide/runtime";

import { setupTraceway, captureSvelteError } from "@tracewayapp/svelte";

import "../app.css";
import PageTransition from "./transition.svelte";

setupTraceway({
  connectionString: PUBLIC_TRACEWAY_CONNECTION_STRING,
  options: {
    debug: dev,
    version: __APP_VERSION__,
  },
});

let { data, children } = $props();

const { pathname } = $derived(data);
// const { locale } = $derived(data);

// Body Classes
const bodyClass = "text-base-12 bg-base-1";

let progress;

onMount(async () => {
  document.body.classList = bodyClass;

  // progress = new ProgressBar({
  //   target: document.querySelector("body"),
  //   props: { color: "#0366d6" }
  // });

  // Perform the following actions in development mode.
  if (dev) {
    if (import.meta.hot) {
      // Preline reinitialization helper
      import.meta.hot.on("vite:afterUpdate", () => {
        // console.log("vite:afterUpdate event", event);
        // if (browser) {
        //   window?.HSCollapse?.autoInit();
        //   window?.HSDropdown?.autoInit();
        //   window?.HSThemeSwitch?.autoInit();
        // }
      });
    }
  }
});

afterNavigate(() => {
  // if (browser) {
  //   window?.HSCollapse.autoInit();
  //   window?.HSDropdown.autoInit();
  //   window?.HSThemeSwitch.autoInit();
  // }
});

// let isLoading = false;

// beforeNavigate(() => (isLoading = true));

beforeNavigate(({ to }) => {
  // console.log("to.route.id", to.route.id);
  if (to?.route?.id) {
    // isLoading = true;
    progress.start();
  }
});

afterNavigate(() => {
  // isLoading = false;
  progress.complete();
});

// $: if (browser) document.body.classList = bodyClass;
// $: ({ pathname } = data);

// $: console.log("isLoading", isLoading, "pathname : ", pathname);
</script>

<!-- {#if isLoading}
  <Loader
    class="absolute left-4 top-6 w-24 transform bg-white dark:bg-black sm:left-1/2 sm:right-1/2 sm:-translate-x-1/2 lg:top-8"
    ><p class="text-sm font-semibold">Loading...</p></Loader
  >
{/if} -->

<a href="#main-content" class="skip-link">Ana içeriğe atla</a>

<ProgressBar color="var(--color-accent-9)" bind:this={progress} />

<Header />
<svelte:boundary onerror={captureSvelteError}>
  <PageTransition url={pathname}>{@render children?.()}</PageTransition>
</svelte:boundary>
<Footer />
<GoogleAnalytics />
<ScrollTop />

<ToastContainer toasts={toasts} let:data>
  <FlatToast data={data} />
</ToastContainer>

<div style="display:none">
  {#each locales as locale (locale)}
    <a href={resolve(localizeHref(page.url.pathname, { locale }))}>{locale}</a>
  {/each}
</div>
